import { Link } from '@ta-interaktiv/contentbricks'
import { RiskText } from 'components/RiskText'
import React from 'react'
import styled from 'styled-components'
const isMobile = window.innerWidth < 712

const RISKCOLORS: { [key: string]: string[] } = {
  none: ['#479260', '#fff'],
  low: ['#F7BD19', '#202346'],
  middle: ["var(--orange-main)", '#fff'],
  high: ["var(--red-dark-1)", '#fff']
}

const StyledRiskLabel = styled.div<{ risk: string }>`
  font-family: var(--font-sans-serif);
  font-size: ${isMobile ? '26px' : '30px'};
  line-height: 1.5em;
  letter-spacing: 0.4px;
  margin-bottom: 30px;
  text-align: center;
  padding: 30px;
  background-color: ${({ risk }) => RISKCOLORS[risk][0]};
  color: ${({ risk }) => RISKCOLORS[risk][1]};
  p {
    color: ${({ risk }) => RISKCOLORS[risk][1]} !important;
    a {
      color: ${({ risk }) => RISKCOLORS[risk][1]} !important;
    }
    svg #Group rect {
      fill: ${({ risk }) => RISKCOLORS[risk][1]} !important;
    }
    margin-top: 15px;
    font-size: 15px;
  }
`
const StyledRisk = styled.div<{
  risk: string
  noBorder: boolean
  noPadding?: boolean
}>`
  margin-bottom: 30px;
  max-width: ${isMobile ? undefined : 'calc(100% - 4px)'};
  border-left: ${({ risk, noBorder }) =>
    noBorder ? undefined : '7px solid ' + RISKCOLORS[risk][0]};
  font-family: ${({ noBorder }) => (noBorder ? undefined : 'var(--font-sans-serif)')};
  padding-left: ${({ noPadding }) => (noPadding ? '0' : '11px')};
  position: relative;
  h5 {
    font-family: ${({ noBorder }) =>
      noBorder ? undefined : 'var(--font-sans-serif)'};
    display: ${({ noBorder }) => (noBorder ? 'none' : 'block')};
  }
  ul {
    padding-left: 17px;
    li {
      margin-bottom: 15px;
    }
  }

  &:last-of-type {
    margin-bottom: 0px;
  }
  h5 {
    font-weight: 600;
    font-size: 22px;
    line-height: 1.4em;
  }
`
const OtherContainer = styled.div`
  border: 1px solid var(--gray-bright-1);
  padding: 20px;
  margin-left: -20px;
  width: calc(100% - 40px);
  margin-top: 30px;
  line-height: 1.3em;
  h4 {
    font-family: var(--font-sans-serif);
    font-weight: 300;
  }
  p {
    font-size: 15px;
    font-family: var(--font-sans-serif);
    margin-bottom: 30px !important;
  }
`

export const RiskAssessment = ({
  user,
  data,
  genderData,
  labels,
  lang = 'de'
}: {
  user: UserInputTypes
  data: FormatedUserRiskDataType
  genderData: FormatedUserDataGenderType
  labels: {
    user: { none: JSX.Element | string; low: JSX.Element | string; middle: JSX.Element | string; high: JSX.Element | string; }
    gender: { [key: string]: string[] }
    frequency: { [key: string]: string }
    groups: { [key: string]: JSX.Element }
    getHelp: JSX.Element// { [key: string]: JSX.Element }
    otherCats: JSX.Element | string// { [key: string]: JSX.Element }
    diclaimer:  JSX.Element//{ [key: string]: JSX.Element }
  }
  lang: 'de' | 'fr'
}) => {
  const { risk = 'low' } = user
  const texts = labels.user
  const riskTexts = labels.groups

  // - DE-Version
  return (
    <RiskTextRoot>
      <div className='ta text'>
        <StyledRiskLabel risk={risk}>
          {texts[risk]}
          {risk !== 'none' && <p>{labels.getHelp}</p>}
        </StyledRiskLabel>
        {risk === 'none' ||
          (risk === 'middle' && (
            <StyledRisk risk={risk} noBorder noPadding>
              {riskTexts[risk]}
            </StyledRisk>
          ))}
        <RiskText riskData={data} userInputs={user} LANGUAGE={lang} />
        {risk !== 'none' && risk !== 'middle' && (
          <StyledRisk risk={risk} noBorder noPadding>
            {riskTexts[risk]}
          </StyledRisk>
        )}
        <OtherContainer>
          <h4>{labels.otherCats}</h4>
          <p>{labels.diclaimer}</p>
          {Object.entries(riskTexts)
            .filter(f => f[0] !== risk)
            .map(([r, text], i) => (
              <StyledRisk risk={r} noBorder={false} key={'styledrisk' + i}>
                {text}
              </StyledRisk>
            ))}
        </OtherContainer>
      </div>
    </RiskTextRoot>
  )
}


const RiskTextRoot=styled.div`
max-width: 100%;
`